import { CUSTOM_ELEMENTS_SCHEMA, ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationComponent } from './navigation.component';
import { MaterialModule } from 'src/app/material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { EntityDataService, EntityDefinitionService, EntityMetadataMap } from '@ngrx/data';
import { compareFeature, Feature } from './model/rootObjectFeature';
import { FeatureDataService } from './service/feature-data.service';
import { FeatureEntityService } from './service/feature-entity.service';
import { SsdpModule } from 'src/app/component/ssdp/ssdp.module';

const entityMetadata: EntityMetadataMap = {
    Feature: {
        selectId: (feature: Feature) => feature.ID,
        sortComparer: compareFeature,
        entityDispatcherOptions: {
            optimisticUpdate: true
        }
    }
};

const components = [NavigationComponent];

@NgModule({
    declarations: [components],
    imports: [CommonModule, FormsModule, ReactiveFormsModule, MaterialModule, AppRoutingModule],

    exports: [components],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class NavigationModule {
    constructor(private eds: EntityDefinitionService, private entityDataService: EntityDataService, private featureDataService: FeatureDataService) {
        eds.registerMetadataMap(entityMetadata);
        entityDataService.registerService('Feature', featureDataService);
    }
    static forRoot(): ModuleWithProviders<NavigationModule> {
        return {
            ngModule: NavigationModule,
            providers: [FeatureEntityService, FeatureDataService] // , RouteGuardService
        };
    }
}
